<template>
  <div class="flex items-center gap-5">
    <div v-for="(symbolID, idx) in symbols" :key="idx">
      <Icon
        v-if="careSymbols[symbolID]"
        :icon="careSymbols[symbolID]"
        size="7"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { careSymbols } from '~/config/careSymbols'

defineProps({
  symbols: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
})
</script>
